export class AtendimentoPsicologos{
    polo:number;
    diretoria:number;
}